import path from 'ramda/src/path'
import map from 'ramda/src/map'
import fieldsPathDescriptionsSelector from 'root/src/client/logic/embedded/selectors/fieldsPathDescriptionsSelector'
import moduleDescriptions from 'root/src/shared/descriptions/modules'

export default (state, { moduleId }) => map(
	fieldPath => path([...fieldPath, 'optionsPromiseType'], moduleDescriptions),
	fieldsPathDescriptionsSelector(state, { moduleId }),
)
